<script>
  /* eslint-disable */
	export default {
		render(h) {
			return (
        <v-layout column={true} wrap={true} justify-center={true} align-center={true} class="p-absolute h-100 disconected">
          <v-flex xs3={true}>
            <v-layout column={true} wrap={true} justify-center={true} align-center={true}>
              <h1 class="my-3">
                Desconectado
              </h1>
              <small class="d-block white--text my-3">Conectese para visualizar los mensajes</small>
            </v-layout>
          </v-flex>
        </v-layout>
      );
		},
	};
</script>

<style scoped>
.disconected {
    left: 0;
    width: 100%;
    height: calc(100vh - 55px - 96px);
    bottom: 0;
    color: #DDDDDD;
    background-color: rgba(0, 0, 0, 0.7);
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/ConnectPanel.vue